var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"color":_vm.labelColor,"label":"","small":""}},[_c('span',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.count)),(_vm.postFix)?_c('span',[_vm._v(_vm._s(_vm.postFix))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }